/**
 * Design-token hex constants for SVG/JSX color props.
 *
 * These mirror the color tokens registered in `tailwind.config.js`. Use these
 * for any context that takes a hex string at runtime (e.g. icon `color`, fill,
 * stroke, inline style). For Tailwind class names use the token directly:
 *   text-primary-500, bg-warning-50, border-error-150
 *
 * Adding a new color: register the token in `tailwind.config.js` first, then
 * mirror it here under the matching scale.
 */

const COLORS = Object.freeze({
  white: '#ffffff',

  // Primary (brand blue)
  primary500: '#2E51CD',
  bluePrimary: '#3b82f6',
  blueDeep: '#2563EB',
  blueDarker: '#1d4ed8',

  // Neutral (grays)
  neutral150: '#F2F4F7',
  neutral500: '#667085',
  neutral650: '#475467',
  neutral700: '#344054',
  neutral900: '#101828',
  gray500: '#6b7280',
  slate500: '#64748b',
  slate700: '#334155',

  // Success (green)
  success450: '#039855',
  success600: '#027A48',
  successGreen: '#12B76A',
  successBright: '#22c55e',

  // Warning (yellow/amber/orange)
  warning525: '#F79009',
  warning625: '#DC6803',
  warning750: '#B54708',
  orange500: '#FB6514',
  amber600: '#ca8a04',
  orangeBright: '#f97316',

  // Error (red)
  error400: '#F04438',
  error500: '#D92D20',
  errorBright: '#ef4444',
  error600: '#B42318',
  error700: '#B91C1C',

  // Info (blue)
  info650: '#155EEF',
});

export default COLORS;
